import React from 'react';
import { MsalProvider as AzureMsalProvider } from '@azure/msal-react';
import { msalInstance } from '../config/msalConfig';

interface MsalProviderProps {
  children: React.ReactNode;
}

export const MsalProvider: React.FC<MsalProviderProps> = ({ children }) => {
  return (
    <AzureMsalProvider instance={msalInstance}>
      {children}
    </AzureMsalProvider>
  );
};
